import React from "react";

import Button from "@cayuse/shared-react.components.button";
import IconButton from "@cayuse/shared-react.components.icon-button";
import { useDictionary } from "hooks";
import { useSelector } from "react-redux";
import {
	saveBudgetBuilderForm,
	updateSponsoredCostsLineItems,
} from "store/actions/budgetBuilder";
import { budgetBuilderSelectors } from "store/selectors";


const LineItemsButtons = (
	{
		editedCategories,
		isEditing,
		isModified,
		handleReset,
		setIsEditing,
	},
) => {
	const dictionary = useDictionary("budgetBuilder.buttonLabels");
	const isLoading = useSelector(budgetBuilderSelectors.isFetching);
	const enableEditing = () => setIsEditing(true);
	const onReset = () => {
		handleReset();
		setIsEditing(false);
	};
	const handleSave = () => {
		setIsEditing(false);
		updateSponsoredCostsLineItems(editedCategories);

		return saveBudgetBuilderForm();
	};

	const cancelButton = () => (
		<Button disabled={!isEditing} onClick={onReset} secondary>
			{dictionary.cancel || "Cancel"}
		</Button>
	);

	const editSaveButton = () => isEditing ? (
		<IconButton
			key="save"
			icon="save"
			labelPosition="left"
			disabled={!isModified}
			busy={isLoading}
			onClick={handleSave}
		>
			{dictionary.save || "Save"}
		</IconButton>
	) : (
		<IconButton
			key="edit"
			icon="pencil-alt"
			labelPosition="left"
			onClick={() => enableEditing()}
		>
			{dictionary.edit || "Edit"}
		</IconButton>
	);


	return ([ cancelButton(), editSaveButton() ]);
};

export default LineItemsButtons;
